<template>
  <div>
     <Icon name="transfer" @click=ping v-if="!started"/>
     <span v-else>
       <template v-for="c in result">
         <span class="ping-circle" :class="{good: c}">&#x25CF;</span>
       </template>
       <br/>
       <span class="font-size: small" v-if="started" >{{(avg*1000).toFixed(3)}} мс</span>
      </span>
  </div>
</template>

<script>
import {ping as pingIp} from "common"

export default {

  name: "Ping",
  
  props: {
    ip: String,
  },
  
  data()
  {
    return {
      started: false,
      result: [],
      avg: 0,
    }
  },
  
  expose: ["ping"],

  methods: {  
    ping()
    {
      this.started = true

      pingIp(this.ip, 5, data =>
      {
        this.result.push(data.reply=="OK")
        this.avg = (this.avg + data.time)/2
      })
    }
  },
  
}
</script>

<style scoped>
.ping-circle
{
  color: red;
  font-size: x-large;
}

.good
{
  color: green !important;
}
</style>
